import { createContext, type FC } from 'react';

import { NurseSenkaTheme } from '../types/NurseSenkaTheme';

import { ThemeProviderProps } from './ThemeProviderProps';
import { createDefaultTheme } from './theme';

export const ThemeContext =
  createContext<NurseSenkaTheme>(createDefaultTheme());
const { Provider } = ThemeContext;

export const ThemeProvider: FC<ThemeProviderProps> = ({ theme, children }) => (
  <Provider value={theme}>{children}</Provider>
);
